import { render, staticRenderFns } from "./v-chart-pie.vue?vue&type=template&id=1b186d81"
import script from "./v-chart-pie.vue?vue&type=script&lang=js"
export * from "./v-chart-pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b186d81')) {
      api.createRecord('1b186d81', component.options)
    } else {
      api.reload('1b186d81', component.options)
    }
    module.hot.accept("./v-chart-pie.vue?vue&type=template&id=1b186d81", function () {
      api.rerender('1b186d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/chart/pie/v-chart-pie.vue"
export default component.exports